import styles from './DadosFornecedor.module.scss';

export default function DadosDoFornecedor() {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>DADOS DO FORNECEDOR</h1>

            <div className={styles.conteudo}>
                <div className={styles.containerInputs}>
                    <div className={styles.inputHorizontal}>
                        <h4>Código: </h4>
                        <p>001</p>
                    </div>

                    <div className={styles.inputHorizontal}>
                        <h4>Razão Social:</h4>
                        <p>ILC CAVALCANTE</p>
                    </div>

                    <div className={styles.inputHorizontal}>
                        <h4>CNPJ: </h4>
                        <p>37.438.442/0001-24</p>
                    </div>
                </div>

                <div className={styles.containerInputs}>
                    <div className={styles.inputHorizontal}>
                        <h4>Insc. Estadual: </h4>
                        <p> </p>
                    </div>

                    <div className={styles.inputHorizontal}>
                        <h4>Insc. Mun.: </h4>
                        <p></p>
                    </div>

                    <div className={styles.inputHorizontal}>
                        <h4>Telefone: </h4>
                        <p> </p>
                    </div>

                    <div className={styles.inputHorizontal}>
                        <h4>Celular: </h4>
                        <p>(92) 9292-8476</p>
                    </div>
                </div>

                <div className={styles.containerInputs}>
                    <div className={styles.inputHorizontal}>
                        <h4>Endereço: </h4>
                        <p>Comunidade São Francisco das chagas do Caribí</p>
                    </div>

                    <div className={styles.inputHorizontal}>
                        <h4>CEP: </h4>
                        <p>69.120-00</p>
                    </div>

                    <div className={styles.inputHorizontal}>
                        <h4>MUN./UF: </h4>
                        <p>Itapiranga - AM</p>
                    </div>
                </div>

                <div className={styles.containerInputs}>
                    <div className={styles.inputHorizontal}>
                        <h4>Email: </h4>
                        <p>profelizangela72@gmail.com</p>
                    </div>

                    <div className={styles.inputHorizontal}>
                        <h4>OBS: </h4>
                        <p> </p>
                    </div>
                </div>
            </div>
        </div>
    )
}